import { Component, Input, Output, EventEmitter } from '@angular/core';

import { ButtonComponent } from '../../atoms/button/button.component';

/**
 * Zero-results placeholder with optional icon, description, and primary call-to-action button.
 */
@Component({
  selector: 'es-empty-state',
  imports: [ButtonComponent],
  template: `
    <div class="flex flex-col items-center justify-center py-12 text-center">
      @if (icon) {
        <span class="text-4xl mb-4 opacity-30">{{ icon }}</span>
      }
      <h3 class="text-lg font-semibold text-[var(--text)]">{{ title }}</h3>
      @if (description) {
        <p class="text-sm text-[var(--text-secondary)] mt-1 max-w-sm">{{ description }}</p>
      }
      @if (actionLabel) {
        <es-button class="mt-4" variant="primary" size="sm" (clicked)="action.emit()">
          {{ actionLabel }}
        </es-button>
      }
    </div>
  `,
})
export class EmptyStateComponent {
  @Input({ required: true }) title!: string;
  @Input() description?: string;
  @Input() icon?: string;
  @Input() actionLabel?: string;
  @Output() action = new EventEmitter<void>();
}
